import { render, staticRenderFns } from "./MemberCenterEditDone.vue?vue&type=template&id=90dcc612&scoped=true&"
import script from "./MemberCenterEditDone.vue?vue&type=script&lang=js&"
export * from "./MemberCenterEditDone.vue?vue&type=script&lang=js&"
import style0 from "./MemberCenterEditDone.vue?vue&type=style&index=0&id=90dcc612&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90dcc612",
  null
  
)

export default component.exports